import { FormControl, FormLabel, MenuItem, Select, type SelectChangeEvent } from '@mui/material';
import type React from 'react';
import useFormControlStyles from 'src/styles/FormControlStyles';

interface FormikInstance {
  handleChange: (event: SelectChangeEvent<string>) => void;
  values: {
    mediaGroupId: string;
    [key: string]: string | number | boolean | null | undefined;
  };
}

interface SelectItem {
  id: string;
  name: string;
}

interface SelectWithLabelProps {
  formik: FormikInstance;
  items: SelectItem[];
  label: string;
  name: string;
}

const SelectWithLabel: React.FC<SelectWithLabelProps> = ({ formik, items, label, name }) => {
  const classes = useFormControlStyles();
  return (
    <FormControl className={classes.formElementStyle}>
      <FormLabel className={classes.formControlLabel} sx={{ mx: 'auto' }} color="primary">
        {label}
      </FormLabel>
      <Select
        name={name}
        onChange={formik.handleChange}
        value={formik.values.mediaGroupId}
        className={classes.formElements}
        color="secondary"
      >
        {items.map((m) => (
          <MenuItem key={m.id + m.name} value={m.id}>
            {m.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectWithLabel;
